export default "__VITE_ASSET__b445403a__"